import {
  Button,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@sandtech-hub-monorepo/ui-kit';
import React, { useState } from 'react';
import { InfoIcon } from 'lucide-react';
import { GetViewerLearningDetailsQuery } from '@sandtech-hub-monorepo/ehub-client';

export type ProgramEnrollment = NonNullable<
  GetViewerLearningDetailsQuery['viewer']['programEnrollments']
>[number] & {
  canDefer: boolean;
  canWithdraw: boolean;
};

interface SelectProgramProps {
  programEnrollments: ProgramEnrollment[];
  onSelect: (x: ProgramEnrollment) => void;
}

export const SelectProgram = ({
  programEnrollments,
  onSelect,
}: SelectProgramProps) => {
  const [programId, setProgramId] = useState('');

  return (
    <div className="flex flex-col items-center gap-4 py-8 max-w-full sm:max-w-md mx-auto">
      <div className="p-6 bg-primary/20 rounded-full text-secondary">
        <InfoIcon height="48" width="48" />
      </div>
      <h2 className="sm:text-2xl text-xl text-center font-semibold">
        Select a program to update
      </h2>
      <div className="text-center my-4">
        You have multiple ongoing programs. Carefully choose which of them you
        want to update.
      </div>
      <Select
        value={programId}
        onValueChange={setProgramId}
        defaultValue="Select program"
      >
        <SelectTrigger className="my-4">
          <SelectValue placeholder="Select program" />
        </SelectTrigger>
        <SelectContent>
          {programEnrollments.map(({ id, program }) => (
            <SelectItem value={id}>{program.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <div className="flex gap-4 sm:flex-row flex-col">
        <Button
          variant="outline"
          className="flex gap-2"
          onClick={() =>
            onSelect(programEnrollments.find(({ id }) => id === programId)!)
          }
        >
          Continue
        </Button>
      </div>
    </div>
  );
};
